import { render } from "./Studebook.vue?vue&type=template&id=8450688c"
import script from "./Studebook.vue?vue&type=script&lang=js"
export * from "./Studebook.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__